import {
  Card,
  CardActions,
  CardContent,
  // Checkbox,
  // FormControlLabel,
  Grid,
  Tooltip,
  Typography,
} from '@mui/material';
import { useFormik } from 'formik';
import { ReactElement, useCallback } from 'react';
import { PmiButton } from 'shell/components/shared/button';
import MunicipalityAutoComplete from 'system/components/shared/search-municipality';
import { MunicipalityVM } from 'system/view-models/municipality';
import * as yup from 'yup';
// import InstitutionType from './type';
import PmiTextField from 'shell/components/shared/text-field';

export interface InstitutionForm {
  code: string;
  name: MunicipalityVM | null;
  description: string;
  officeNumber: number;
  mayor: string;
  mayorFiscalCode: string;
  istat: string;
  province: string;
  anpr: boolean;
  lastUpdate?: string;
  direction?: string;
}

const validationSchema = yup.object({
  name: yup.object().nullable().shape({}).required('Campo obbligatorio'),
  istat: yup
    .string()
    .required('Campo obbligatorio')
    .min(6, 'Minimo 6 cifre')
    .max(6, 'Massimo 6 cifre'),
  mayor: yup.string().required('Campo obbligatorio'),
  mayorFiscalCode: yup.string().required('Campo obbligatorio'),
  officeNumber: yup
    .number()
    .nullable()
    .notRequired()
    .max(2147483647, 'Il campo supera il range massimo che è di 2147483647'), // max value integer java
});

interface FormInstitutionProps {
  onOk: (form?: InstitutionForm) => void;
  onCancel: (form?: InstitutionForm) => void;
  title: string;
  children?: ReactElement;
  disabled?: boolean;
  initialValues?: InstitutionForm;
}

const FormInstitution = ({
  onOk,
  onCancel,
  title,
  children,
  disabled = false,
  initialValues,
}: FormInstitutionProps): React.ReactElement => {
  const onSubmit = useCallback(
    (formValues) => {
      onOk(formValues);
    },
    [onOk]
  );

  const filtersInstitutionForm = useFormik({
    initialValues: initialValues || {
      code: '',
      description: '',
      officeNumber: 0,
      istat: '',
      province: '',
      mayor: '',
      mayorFiscalCode: '',
      lastUpdate: '',
      anpr: false,
      name: null,
      direction: '',
    },
    validationSchema: validationSchema,
    onSubmit,
    enableReinitialize: true,
  });

  // const handleAnprFieldChange = (event: ChangeEvent<HTMLInputElement>) => {
  //   const form: InstitutionForm = {
  //     ...filtersInstitutionForm.values,
  //     anpr: event.target.checked,
  //     type: !event.target.checked ? 'N' : '',
  //   };
  //   filtersInstitutionForm.setValues(form);
  // };

  return (
    <Card raised className="pmi-my-3">
      <form onSubmit={filtersInstitutionForm.handleSubmit}>
        <CardContent style={{ padding: '24px' }}>
          <Typography gutterBottom variant="h5" component="h2" color="secondary">
            {title}
          </Typography>
          <div style={{ padding: '24px 0 0 0' }}>
            <Grid container spacing={2} alignItems="center">
              <Grid item xs={12} md={4}>
                <Tooltip arrow title="Il campo è generato automaticamente">
                  <div>
                    <PmiTextField
                      aria-label="Codice"
                      label="Codice"
                      id="code"
                      name="code"
                      fullWidth
                      type="text"
                      variant="outlined"
                      value={filtersInstitutionForm.values.code}
                      disabled
                      onChange={filtersInstitutionForm.handleChange}
                      error={
                        filtersInstitutionForm.touched.code &&
                        Boolean(filtersInstitutionForm.errors.code)
                      }
                      helperText={filtersInstitutionForm.errors.code}
                      inputProps={{
                        maxLength: 2,
                      }}
                    />
                  </div>
                </Tooltip>
              </Grid>
              <Grid item xs={12} md={4}>
                {/* <InstitutionType
                  disabled={disabled}
                  value={filtersInstitutionForm.values.type}
                  onChange={filtersInstitutionForm.handleChange}
                /> */}
              </Grid>
              {/* <Grid item>
                <FormControlLabel
                  control={
                    <Checkbox
                      id="anpr"
                      name="anpr"
                      disabled={disabled}
                      checked={filtersInstitutionForm.values.anpr}
                      onChange={handleAnprFieldChange}
                      inputProps={{ 'aria-label': 'anpr' }}
                    />
                  }
                  label="ANPR"
                />
              </Grid> */}
              <Grid item xs={12} md={8}>
                <div className="pmi-d-flex pmi-align-items-center">
                  <span>Comune di &nbsp;</span>
                  <MunicipalityAutoComplete
                    required
                    error={
                      filtersInstitutionForm.touched.name &&
                      Boolean(filtersInstitutionForm.errors.name)
                    }
                    selectedValue={filtersInstitutionForm.values.name || { description: '' }}
                    handleChange={(element) => {
                      filtersInstitutionForm.setValues({
                        ...filtersInstitutionForm.values,
                        istat: element?.istat || '',
                        province: element?.province || '',
                        name: element || null,
                      });
                    }}
                    disabled={disabled}
                    label="Nome"
                  />
                </div>
              </Grid>
              <Grid item xs={12} md={2}>
                <PmiTextField
                  aria-label="provincia"
                  label="Provincia"
                  id="province"
                  name="province"
                  fullWidth
                  inputProps={{
                    maxLength: 2,
                  }}
                  type="text"
                  variant="outlined"
                  disabled
                  value={filtersInstitutionForm.values.province}
                  onChange={filtersInstitutionForm.handleChange}
                  error={
                    filtersInstitutionForm.touched.province &&
                    Boolean(filtersInstitutionForm.errors.province)
                  }
                  helperText={filtersInstitutionForm.errors.province}
                />
              </Grid>
              <Grid item xs={12} md={2}>
                <PmiTextField
                  aria-label="Istat"
                  label="ISTAT"
                  id="istat"
                  name="istat"
                  fullWidth
                  inputProps={{
                    maxLength: 6,
                    pattern: '[0-9]*',
                  }}
                  type="text"
                  variant="outlined"
                  disabled
                  value={filtersInstitutionForm.values.istat}
                  onChange={filtersInstitutionForm.handleChange}
                  error={
                    filtersInstitutionForm.touched.istat &&
                    Boolean(filtersInstitutionForm.errors.istat)
                  }
                  helperText={filtersInstitutionForm.errors.istat}
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <PmiTextField
                  aria-label="numero ufficio stato civile"
                  label="Numero ufficio Stato Civile"
                  id="officeNumber"
                  name="officeNumber"
                  fullWidth
                  type="number"
                  variant="outlined"
                  value={filtersInstitutionForm.values.officeNumber}
                  onChange={filtersInstitutionForm.handleChange}
                  disabled={disabled}
                  error={
                    filtersInstitutionForm.touched.officeNumber &&
                    Boolean(filtersInstitutionForm.errors.officeNumber)
                  }
                  helperText={filtersInstitutionForm.errors.officeNumber}
                />
              </Grid>
              <Grid item container spacing={2} xs={12}>
                <Grid item xs={12} md={4}>
                  <PmiTextField
                    aria-label="contesto ultimo aggiornamento"
                    label="Contesto ultimo aggiornamento"
                    id="lastUpdate"
                    name="lastUpdate"
                    fullWidth
                    variant="outlined"
                    value={filtersInstitutionForm.values.lastUpdate || ''}
                    onChange={filtersInstitutionForm.handleChange}
                    disabled={disabled}
                    error={
                      filtersInstitutionForm.touched.lastUpdate &&
                      Boolean(filtersInstitutionForm.errors.lastUpdate)
                    }
                    helperText={filtersInstitutionForm.errors.lastUpdate}
                  />
                </Grid>
              </Grid>
              <Grid item container spacing={2} xs={12}>
                <Grid item xs={12} md={4}>
                  <PmiTextField
                    aria-label="sindaco"
                    label="Sindaco"
                    id="mayor"
                    name="mayor"
                    fullWidth
                    variant="outlined"
                    value={filtersInstitutionForm.values.mayor || ''}
                    onChange={filtersInstitutionForm.handleChange}
                    disabled={disabled}
                    error={
                      filtersInstitutionForm.touched.mayor &&
                      Boolean(filtersInstitutionForm.errors.mayor)
                    }
                    helperText={filtersInstitutionForm.errors.mayor}
                  />
                </Grid>
                <Grid item xs={12} md={4}>
                  <PmiTextField
                    aria-label="codice fiscale"
                    label="Codice fiscale"
                    id="mayorFiscalCode"
                    name="mayorFiscalCode"
                    fullWidth
                    variant="outlined"
                    value={filtersInstitutionForm.values.mayorFiscalCode || ''}
                    onChange={filtersInstitutionForm.handleChange}
                    disabled={disabled}
                    error={
                      filtersInstitutionForm.touched.mayorFiscalCode &&
                      Boolean(filtersInstitutionForm.errors.mayorFiscalCode)
                    }
                    helperText={filtersInstitutionForm.errors.mayorFiscalCode}
                  />
                </Grid>
              </Grid>
              <Grid item xs={12} md={4}>
                <PmiTextField
                  aria-label="Descrizione direzione"
                  label="Descrizione direzione"
                  id="direction"
                  name="direction"
                  fullWidth
                  inputProps={{
                    maxLength: '240',
                  }}
                  variant="outlined"
                  value={filtersInstitutionForm.values.direction || ''}
                  onChange={filtersInstitutionForm.handleChange}
                  disabled={disabled}
                  error={
                    filtersInstitutionForm.touched.direction &&
                    Boolean(filtersInstitutionForm.errors.direction)
                  }
                  helperText={filtersInstitutionForm.errors.direction}
                />
              </Grid>
            </Grid>
          </div>
        </CardContent>
        {children}
        <CardActions style={{ padding: '24px 24px 16px 24px' }}>
          <PmiButton variant="contained" color="primary" type="submit" disabled={disabled}>
            Conferma
          </PmiButton>
          <PmiButton
            variant="outlined"
            color="cdmBrand"
            onClick={() => {
              onCancel(filtersInstitutionForm.values);
            }}
          >
            Indietro
          </PmiButton>
        </CardActions>
      </form>
    </Card>
  );
};

FormInstitution.displayName = 'Form Institution component';

export default FormInstitution;
